import { DatePickerInput } from "@mantine/dates";
import type { DatePickerInputProps } from "@mantine/dates";
import { fromCalendarDate } from "../utils/calendarDate";

interface DateFieldProps {
  label?: string;
  value?: Date | null;
  onChange: (date: Date | null) => void;
  required?: boolean;
  error?: React.ReactNode;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
  clearable?: boolean;
}

export function DateField({
  label,
  value,
  onChange,
  required,
  error,
  minDate,
  maxDate,
  placeholder = "Select date",
  clearable = true,
}: DateFieldProps) {
  return (
    <DatePickerInput
      label={label}
      value={value}
      onChange={(date) => onChange(fromCalendarDate(date))}
      required={required}
      error={error}
      minDate={minDate}
      maxDate={maxDate}
      placeholder={placeholder}
      clearable={clearable}
      valueFormat="YYYY-MM-DD"
    />
  );
}
